import { StateCreator } from "zustand";
import { Store } from "./types";
import { fetchDocuments as fetchDocumentsAPI, getDocument } from "@/lib/api/document";
import { toast } from "@/hooks/use-toast";

/**
 * Document reads for the search page.
 *
 * This slice used to poll every 30 seconds and raise "Document verwerkt" /
 * "Verwerken mislukt" toasts, because it was watching the progress of uploads
 * through the `document_event_handler` job. That upload path is gone, so there is
 * nothing to watch: the polling and those toasts went with it.
 *
 * What is left is what the search page still calls. Note that `loadDocuments`
 * returns FILE and URL documents only — the default `types` on the backend query
 * — so with uploads removed the list is permanently empty. `loadDocument`
 * (singular) is the one that matters: it fetches by id regardless of type, which
 * is how `SearchResults` resolves a knowledge item and opens it in TOPdesk.
 */
export const createDocumentSlice: StateCreator<
  Store,
  [],
  [],
  Pick<Store, "documents" | "loadDocument" | "loadDocuments">
> = (set, get) => ({
  documents: [],
  loadDocument: async (documentId: string) => {
    const document = await getDocument(documentId);
    set({ documents: [...get().documents, document] });
    return document;
  },
  loadDocuments: async () => {
    try {
      set({ documents: await fetchDocumentsAPI() });
    } catch (error) {
      console.error("Error loading documents:", error);
      toast({
        title: "Fout",
        description: "Documenten laden is mislukt. Probeer het later opnieuw.",
        variant: "destructive",
      });
    }
  },
});
